import { MapPin, Users } from 'lucide-react';

export const SERVICE_CONFIG = {
  day_program: { label: 'Explore Program', maxGroups: 8, ratio: '1:3', fixedTime: true, timeIn: '09:00', timeOut: '16:00', color: '#6B3FA0', dotColor: 'bg-[#9B7ED8]' },
  employment: { label: 'Employment', maxSlots: 10, ratio: '1:1', fixedTime: false, color: '#E65100', dotColor: 'bg-[#FFB74D]' },
  in_home: { label: 'IHCS', maxSlots: 20, ratio: '1:1', fixedTime: false, color: '#1B5E20', dotColor: 'bg-[#81C784]' },
  private_pay: { label: 'Private Pay', maxSlots: 15, ratio: '1:3', fixedTime: false, color: '#0077B6', dotColor: 'bg-[#4FC3F7]' },
};

export const SERVICE_STYLES = {
  day_program: 'bg-[#EDE7F6] text-[#2D1B4E] border-[#9B7ED8]',
  in_home: 'bg-[#E8F5E9] text-[#1B5E20] border-[#81C784]',
  employment: 'bg-[#FFF3E0] text-[#E65100] border-[#FFB74D]',
  private_pay: 'bg-[#E1F5FE] text-[#01579B] border-[#4FC3F7]',
};

export const WEEK_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export function StaffCountBadge({ count }) {
  return <span className="flex items-center gap-1 text-xs font-semibold"><Users className="h-3 w-3" /> {count} staff</span>;
}
